import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import FallbackComponent from '../FallbackComponent/FallbackComponent.esm.js';
import { useNucleobaseEngine } from '../NucleobaseEngineContext/NucleobaseEngineContext.esm.js';
import { TextCopyContextProvider } from '../TextCopyContext/TextCopyContext.esm.js';
import { useUpdateFields } from '../TextVariablesContext/index.esm.js';
import { useNucleobaseComponentMapContext } from '../NucleobaseComponentsMap/index.esm.js';

/**
 * BaseNucleobaseComponent is an generic component that you should use to show any component
 *
 */
var BaseNucleobaseComponent = function (_a) {
    var children = _a.children, overrideComponentName = _a.componentName, source = _a.source, rootElementProps = _a.rootElementProps, classes = _a.classes, BaseComponent = _a.BaseComponent, onLoad = _a.onLoad, rest = __rest(_a, ["children", "componentName", "source", "rootElementProps", "classes", "BaseComponent", "onLoad"]);
    var nucleobaseComponentsMap = useNucleobaseComponentMapContext();
    var nucleobaseEngine = useNucleobaseEngine({ overrideComponentName: overrideComponentName, source: source });
    if (!nucleobaseEngine)
        return null;
    var isLoading = nucleobaseEngine.isLoading, fields = nucleobaseEngine.fields, componentName = nucleobaseEngine.componentName, contentId = nucleobaseEngine.contentId;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _b = useUpdateFields({ fields: fields }), updatedFields = _b.updatedFields, originalFields = _b.originalFields;
    if (isLoading) {
        return null;
    }
    if (!componentName) {
        console.warn("No component name ".concat(componentName, " source:").concat(JSON.stringify(source))); // eslint-disable-line no-console
        return null;
    }
    var Component = nucleobaseComponentsMap[componentName];
    if (!Component) {
        console.warn("No component for ".concat(componentName, " in ").concat(Object.keys(nucleobaseComponentsMap))); // eslint-disable-line no-console
        return null;
    }
    if (!fields || Object.keys(fields).length === 0)
        return null;
    var objectSource = typeof source !== 'string' ? source : {};
    return (React.createElement(ErrorBoundary, { FallbackComponent: FallbackComponent },
        React.createElement(TextCopyContextProvider, { source: objectSource },
            React.createElement(Component, __assign({ BaseComponent: BaseComponent, classes: classes, fields: updatedFields, id: contentId, onLoad: onLoad, originalFields: originalFields, rootElementProps: rootElementProps }, rest), children))));
};

export { BaseNucleobaseComponent as default };
//# sourceMappingURL=BaseNucleobaseComponent.esm.js.map
